import { createSlice } from "@reduxjs/toolkit";
import {
  getDailyUserStatistics,
  getBarStatistics,
  getHotStatistics,
  getPhotocardNewsStatistics,
  getPushStatistics,
  getSnapStatistics,
  getSummaryStatistics,
  getWallpaperStatistics,
  getAcquisitionStatistics,
  getRegionalCityStatistics,
  getRegionalTownStatistics,
  getUVLogBarStatistics,
} from "./thunk";

export interface IState {
  dailyUserStatistics: any;
  isDailyUserStatisticLoading: boolean;
  isDailyUserStatisticSuccess: boolean;

  summaryStatistics: any;
  isSummaryStatisticLoading: boolean;
  isSummaryStatisticSuccess: boolean;

  hotStatistics: any;
  isHotStatisticLoading: boolean;
  isHotStatisticSuccess: boolean;

  wallpaperStatistics: any;
  isWallpaperStatisticLoading: boolean;
  isWallpaperStatisticSuccess: boolean;

  photocardNewsStatistics: any;
  isPhotocardNewsStatisticLoading: boolean;
  isPhotocardNewsStatisticSuccess: boolean;

  snapStatistics: any;
  isSnapStatisticLoading: boolean;
  isSnapStatisticSuccess: boolean;

  pushStatistics: any;
  isPushStatisticLoading: boolean;
  isPushStatisticSuccess: boolean;

  dailyBarStatistics: any;
  isDailyBarStatisticLoading: boolean;
  isDailyBarStatisticSuccess: boolean;

  acquisitionStatistics: any;
  isAcquisitionStatisticLoading: boolean;
  isAcquisitionStatisticSuccess: boolean;

  regionalCityStatistics: any;
  isRegionalCityStatisticLoading: boolean;
  isRegionalCityStatisticSuccess: boolean;

  regionalTownStatistics: any;
  isRegionalTownStatisticLoading: boolean;
  isRegionalTownStatisticSuccess: boolean;


  UVLogBarStatistics: any;
  isUVLogBarStatisticLoading: boolean;
  isUVLogBarStatisticSuccess: boolean;


  error: any;
}

export const initialState: IState = {
  dailyUserStatistics: null,
  isDailyUserStatisticLoading: false,
  isDailyUserStatisticSuccess: false,

  summaryStatistics: null,
  isSummaryStatisticLoading: false,
  isSummaryStatisticSuccess: false,

  hotStatistics: null,
  isHotStatisticLoading: false,
  isHotStatisticSuccess: false,

  wallpaperStatistics: null,
  isWallpaperStatisticLoading: false,
  isWallpaperStatisticSuccess: false,

  photocardNewsStatistics: null,
  isPhotocardNewsStatisticLoading: false,
  isPhotocardNewsStatisticSuccess: false,

  snapStatistics: null,
  isSnapStatisticLoading: false,
  isSnapStatisticSuccess: false,

  pushStatistics: null,
  isPushStatisticLoading: false,
  isPushStatisticSuccess: false,

  dailyBarStatistics: null,
  isDailyBarStatisticLoading: false,
  isDailyBarStatisticSuccess: false,

  acquisitionStatistics: null,
  isAcquisitionStatisticLoading: false,
  isAcquisitionStatisticSuccess: false,

  regionalCityStatistics: null,
  isRegionalCityStatisticLoading: false,
  isRegionalCityStatisticSuccess: false,

  regionalTownStatistics: null,
  isRegionalTownStatisticLoading: false,
  isRegionalTownStatisticSuccess: false,

  UVLogBarStatistics: null,
  isUVLogBarStatisticLoading: false,
  isUVLogBarStatisticSuccess: false,

  error: {},
};

const StatisticSlice = createSlice({
  name: "Statistic",
  initialState,
  reducers: {
    changeStatusCampaignsAction(state: any, action: any) {
      state.campaignStatistics = action.payload;
    },
    changeStatusFlowedKeywordAnalysisAction(state: any, action: any) {
      state.flowedKeywordAnalysis = action.payload;
    },
  },
  extraReducers: (builder) => {
    //Daily Bar Statistics
    builder.addCase(getBarStatistics.pending, (state: IState, action: any) => {
      state.isDailyBarStatisticLoading = true;
    });
    builder.addCase(
      getBarStatistics.fulfilled,
      (state: IState, action: any) => {
        state.dailyBarStatistics = action.payload.data;
        state.isDailyBarStatisticSuccess = true;
        state.isDailyBarStatisticLoading = false;
      }
    );
    builder.addCase(getBarStatistics.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isDailyBarStatisticSuccess = false;
      state.isDailyBarStatisticLoading = false;
    });

    //Daily User Statistics
    builder.addCase(
      getDailyUserStatistics.pending,
      (state: IState, action: any) => {
        state.isDailyUserStatisticLoading = true;
      }
    );
    builder.addCase(
      getDailyUserStatistics.fulfilled,
      (state: IState, action: any) => {
        state.dailyUserStatistics = action.payload.data;
        state.isDailyUserStatisticSuccess = true;
        state.isDailyUserStatisticLoading = false;
      }
    );
    builder.addCase(
      getDailyUserStatistics.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isDailyUserStatisticSuccess = false;
        state.isDailyUserStatisticLoading = false;
      }
    );

    //Summary Statistics
    builder.addCase(
      getSummaryStatistics.pending,
      (state: IState, action: any) => {
        state.isSummaryStatisticLoading = true;
      }
    );
    builder.addCase(
      getSummaryStatistics.fulfilled,
      (state: IState, action: any) => {
        state.summaryStatistics = action.payload.data;
        state.isSummaryStatisticSuccess = true;
        state.isSummaryStatisticLoading = false;
      }
    );
    builder.addCase(
      getSummaryStatistics.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isSummaryStatisticSuccess = false;
        state.isSummaryStatisticLoading = false;
      }
    );

    //Hot Statistics
    builder.addCase(getHotStatistics.pending, (state: IState, action: any) => {
      state.isHotStatisticLoading = true;
    });
    builder.addCase(
      getHotStatistics.fulfilled,
      (state: IState, action: any) => {
        state.hotStatistics = action.payload.data;
        state.isHotStatisticSuccess = true;
        state.isHotStatisticLoading = false;
      }
    );
    builder.addCase(getHotStatistics.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isHotStatisticSuccess = false;
      state.isHotStatisticLoading = false;
    });

    //Wallpaper Statistics
    builder.addCase(
      getWallpaperStatistics.pending,
      (state: IState, action: any) => {
        state.isWallpaperStatisticLoading = true;
      }
    );
    builder.addCase(
      getWallpaperStatistics.fulfilled,
      (state: IState, action: any) => {
        state.wallpaperStatistics = action.payload.data;
        state.isWallpaperStatisticSuccess = true;
        state.isWallpaperStatisticLoading = false;
      }
    );
    builder.addCase(
      getWallpaperStatistics.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isWallpaperStatisticSuccess = false;
        state.isWallpaperStatisticLoading = false;
      }
    );

    //PhotocardNews Statistics
    builder.addCase(
      getPhotocardNewsStatistics.pending,
      (state: IState, action: any) => {
        state.isPhotocardNewsStatisticLoading = true;
      }
    );
    builder.addCase(
      getPhotocardNewsStatistics.fulfilled,
      (state: IState, action: any) => {
        state.photocardNewsStatistics = action.payload.data;
        state.isPhotocardNewsStatisticSuccess = true;
        state.isPhotocardNewsStatisticLoading = false;
      }
    );
    builder.addCase(
      getPhotocardNewsStatistics.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isPhotocardNewsStatisticSuccess = false;
        state.isPhotocardNewsStatisticLoading = false;
      }
    );

    //Snap statistics
    builder.addCase(getSnapStatistics.pending, (state: IState, action: any) => {
      state.isSnapStatisticLoading = true;
    });
    builder.addCase(
      getSnapStatistics.fulfilled,
      (state: IState, action: any) => {
        state.snapStatistics = action.payload.data;
        state.isSnapStatisticSuccess = true;
        state.isSnapStatisticLoading = false;
      }
    );
    builder.addCase(
      getSnapStatistics.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isSnapStatisticSuccess = false;
        state.isSnapStatisticLoading = false;
      }
    );

    //Push statistics
    builder.addCase(getPushStatistics.pending, (state: IState, action: any) => {
      state.isPushStatisticLoading = true;
    });
    builder.addCase(
      getPushStatistics.fulfilled,
      (state: IState, action: any) => {
        state.pushStatistics = action.payload.data;
        state.isPushStatisticSuccess = true;
        state.isPushStatisticLoading = false;
      }
    );
    builder.addCase(
      getPushStatistics.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isPushStatisticSuccess = false;
        state.isPushStatisticLoading = false;
      }
    );

    //Acquisition statistics
    builder.addCase(getAcquisitionStatistics.pending, (state: IState, action: any) => {
      state.isAcquisitionStatisticLoading = true;
    });
    builder.addCase(getAcquisitionStatistics.fulfilled,
      (state: IState, action: any) => {
        state.acquisitionStatistics = action.payload.data;
        state.isAcquisitionStatisticSuccess = true;
        state.isAcquisitionStatisticLoading = false;
      }
    );
    builder.addCase(getAcquisitionStatistics.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isAcquisitionStatisticSuccess = false;
        state.isAcquisitionStatisticLoading = false;
      }
    );

    //Regional city statistics
    builder.addCase(getRegionalCityStatistics.pending, (state: IState, action: any) => {
      state.isRegionalCityStatisticLoading = true;
    });
    builder.addCase(
      getRegionalCityStatistics.fulfilled,
      (state: IState, action: any) => {
        state.regionalCityStatistics = action.payload.data;
        state.isRegionalCityStatisticSuccess = true;
        state.isRegionalCityStatisticLoading = false;
      }
    );
    builder.addCase(
      getRegionalCityStatistics.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isRegionalCityStatisticSuccess = false;
        state.isRegionalCityStatisticLoading = false;
      }
    );


    //Regional town statistics
    builder.addCase(getRegionalTownStatistics.pending, (state: IState, action: any) => {
      state.isRegionalTownStatisticLoading = true;
    });
    builder.addCase(
      getRegionalTownStatistics.fulfilled,
      (state: IState, action: any) => {
        state.regionalTownStatistics = action.payload.data;
        state.isRegionalTownStatisticSuccess = true;
        state.isRegionalTownStatisticLoading = false;
      }
    );
    builder.addCase(
      getRegionalTownStatistics.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isRegionalTownStatisticSuccess = false;
        state.isRegionalTownStatisticLoading = false;
      }
    );


    //UV Log Bar statistics
    builder.addCase(getUVLogBarStatistics.pending, (state: IState, action: any) => {
      state.isUVLogBarStatisticLoading = true;
    });
    builder.addCase(
      getUVLogBarStatistics.fulfilled,
      (state: IState, action: any) => {
        state.UVLogBarStatistics = action.payload.data;
        state.isUVLogBarStatisticSuccess = true;
        state.isUVLogBarStatisticLoading = false;
      }
    );
    builder.addCase(
      getUVLogBarStatistics.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isUVLogBarStatisticSuccess = false;
        state.isUVLogBarStatisticLoading = false;
      }
    );


  },
});

export const {
  changeStatusCampaignsAction,
  changeStatusFlowedKeywordAnalysisAction,
} = StatisticSlice.actions;

export default StatisticSlice.reducer;